import React, { CSSProperties } from 'react';

export const Text = ({
  text,
  className,
  style,
}: {
  text: string;
  className?: string;
  style?: CSSProperties;
}) => (
  <span className={className} style={style}>
    {text}
  </span>
);

export const Label = Text;

export const Error = ({ text }: { text: string }) => (
  <span className="error font--12" role="alert">
    {text}
  </span>
);
